import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { useStore } from 'zustand';
import cx from 'classnames';
import Conversation from '@/widget/ui/components/conversations/Conversation';
import ConversationsList from '@/widget/ui/components/conversations/List';
import closeIcon from '@/widget/ui/images/close.svg';
import { ReactSVG } from 'react-svg';
import WidgetNavigator from '../WidgetNavigator';
import styles from './WidgetBody.module.scss';

function WidgetBody() {
  const { settings, store } = useChatWidgetContext();
  const { customTrigger, isMobile, host } = settings;
  const mode = useStore(store, (state) => state.mode);
  const setOpen = useStore(store, (state) => state.setOpen);

  const close = () => {
    if (!customTrigger) { setOpen(false); }
    window.parent.postMessage({
      action: 'sc-chat-widget:closed',
    }, '*');
  };

  return (
    <div className={cx(styles.body, styles[mode], { [styles.mobile]: isMobile })}>
      {mode === 'main' && <WidgetNavigator />}
      {mode === 'list' && (
        <ConversationsList />
      )}
      {mode === 'conversation' && <Conversation />}
      <div className={styles.closeButton} onClick={close}>
        <ReactSVG src={host + closeIcon} />
      </div>
    </div>
  );
}

export default WidgetBody;
